import { Injectable } from '@angular/core';
import { QualitasIcon, completeIconSet } from './icons-js';

@Injectable({
  providedIn: 'root'
})
export class IconRegistryService {
  private registry = new Map<string, string>();

  constructor() {
    // If in the future we want to go fully lazy load, we can register specific icons per module.
    // At the moment, for convenience, all icons are registered at startup.
    this.registerIcons(completeIconSet);
  }

  registerIcons(icons: QualitasIcon[]): void {
    icons.forEach((icon: QualitasIcon) =>
      this.registry.set(icon.name.toString(), icon.data)
    );
  }

  getIcon(iconName: string): string | undefined {
    if (!this.registry.has(iconName)) {
      // TODO: If a rewquested icon is not existing animal text should be displayed
      return undefined;
    }

    return this.registry.get(iconName);
  }
}
